var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block-loader",attrs:{"role":"status","aria-live":"polite"}},[_c('div',{staticClass:"block-loader__inner"},[_c('span',{staticClass:"spinner"}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('DASHBOARD.LOADING')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }